import React from "react";
import { Link } from "react-router-dom";
import ReactDOM from 'react-dom/client';
import PrivacyPolicy from '../PrivacyPolicy.js';
import TermsofUse from '../TermsofUse.js';
import ShareMonitoring from './ShareMonitoring.js';
const toekn_id="dskdjks394839048";
const today = new Date();
const URL="./ShareMonitoring?token="+`${toekn_id}`;
function PublicFooter() 
{
   const showPrivacyPolicy=()=>
    {
      const root = ReactDOM.createRoot(document.getElementById('root'));
      root.render(<PrivacyPolicy/>);
    }
    const showTermsofUse=()=>
      {
        const root = ReactDOM.createRoot(document.getElementById('root'));
        root.render(<TermsofUse/>);
      }
      const Sharelink=()=>
        {
          const root = ReactDOM.createRoot(document.getElementById('root'));
          root.render(<ShareMonitoring token={toekn_id}/>);
        }
  return (
  <>
  <footer id="footer">
  <div class="container">
    <div class="row align-items-baseline footer-top">
      {/*
      <div class="col-12 text-center"> <img src="../img/avt-w.png" class="footer-logo"/> </div>*/}
      <div class="col-12">
        <ul class="footerList">
          <li><a href="#">Support</a></li>
          <li><a href="#">Services</a></li>
          <li><a href="#" onClick={showTermsofUse}>Terms of Use</a></li>
          <li><a href="#" onClick={showPrivacyPolicy}>Privacy Policy</a></li>          
           {/*<li><a href="index.html" >Contact</a></li>*/}
        </ul>
      </div>
    </div>
      
      <div class="footer-bottom clearfix">
  <div class="container text-center">Copyright  ©{today.getFullYear()}  All Rights Reserved by AVAAL Technologies India Pvt. Ltd.  </div>
</div>
  </div> 
</footer>
</>
  );
}


export default PublicFooter;